import { Link } from "react-router-dom";
import { siteMeta, footerColumns } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-xl bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-logo text-2xl text-background-50">{siteMeta.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80 max-w-md">
              {siteMeta.slogan}。我们把吃瓜现场之外的网友讨论、评论区观点与舆论反应整理成话题，让每一次围观都能看到不同立场。
            </p>
            <div className="mt-6 flex flex-col gap-2 text-sm text-background-200/80">
              <span className="inline-flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                {siteMeta.email}
              </span>
              <span className="inline-flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                {siteMeta.workingHours}
              </span>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="text-base font-bold text-background-50 mb-4">{col.title}</h3>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/75 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/60">
          <p>
            © {year} {siteMeta.name} · 内容仅为公开讨论整理，不代表本站立场
          </p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <span>理性围观 · 尊重边界</span>
            <span className="hidden sm:inline">整理于 {siteMeta.since} 年</span>
          </p>
        </div>
      </div>
    </footer>
  );
}